/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useState, useCallback } from 'react';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import MikeButton from '../mike-button/MikeButton';
import { useTypedSelector } from '../../reducers';
import { useAppDispatch } from '../../store/store';
import { userSet } from '../../reducers/auth';
import { backendApi } from '../../apis/apiSlice';
import { resetMeasures } from '../../reducers/measures';
import { resetLegend } from '../../reducers/legend';

interface IProps { 
  logInLabel?: string;
  userLabel?: string;
  flat?: boolean;  
}

const userDetailsPopperStyle = css`
  &.MuiPopper-root {    
    z-index: 100000;
    margin-top: ${mikeSharedTheme.spacing(0.25)};
    max-width: 50%;
  }
`;

const buttonsContainerStyle = css`
  display: flex; 
  justify-content: end;
  align-items: center;
`;

const textStyle = css`
  padding-bottom: ${mikeSharedTheme.spacing(1)};
`;

export const LOGGINGOUT = 'loggingOut';

const LoginButton = (props: IProps) => {
  const {
    userLabel = 'Institution'
  } = props;

  const user = useTypedSelector((state) => state.auth.user);
  const dispatch = useAppDispatch()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [userDetailsShown, setUserDetailsShown] = useState(false);

  const handleLogout = async () => {
    dispatch(userSet(null));
    dispatch(resetMeasures());
    dispatch(resetLegend());
    backendApi.util.resetApiState();
    window.location.reload();    
  };

  const handleClickAway = useCallback(() => {
    setAnchorEl(null);
    setUserDetailsShown(false);
  }, []);

  const toggleUserDetails = useCallback(
    (event: any) => {
      if (!userDetailsShown){
        setAnchorEl(event.currentTarget);
      }
      setUserDetailsShown(!userDetailsShown);
    },
    [userDetailsShown],
  );

  const userName = user && user.name ? userLabel + ': ' + user.name : ''; 
  const email = user ?  'E-Mail: ' + user.email : '';  

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <MikeButton
          color="primary"
          onClick={toggleUserDetails}                  
        >
          {"Abmelden"}
        </MikeButton>
        <Popper
          anchorEl={anchorEl}
          placement="bottom-end"
          open={userDetailsShown}
          disablePortal={false}
          onClick={toggleUserDetails}
          modifiers={[{
            name: 'preventOverflow',
            enabled: true,
            options: {
              rootBoundary: 'window'
            } 
          }]}
          css={userDetailsPopperStyle}
        >
          <Paper elevation={2} style={{ padding: 16 }}>
            <div>
              {userName && <Typography css={textStyle}>{userName}</Typography>}             
              <Typography css={textStyle}>{email}</Typography> 
              <div css={buttonsContainerStyle}>
                <MikeButton color="secondary" variant="contained" size="small" onClick={handleLogout}>
                  {"Abmelden"}
                </MikeButton>
              </div>
            </div>
          </Paper>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default LoginButton;
